<template>
  <b-card tag="section"
          header-class="bg-lightgreen">
    <b-card-title class="h5">
      <b-icon icon="diagram3-fill"></b-icon>
      綜合辨識結果
    </b-card-title>
    <b-card-text class="h5">
      <b-spinner v-if="isLoad"
                 type="grow"
                 variant="primary"
                 label="Spinning"></b-spinner>
      <template v-else>{{ level | displayText }} 級</template>
    </b-card-text>
  </b-card>
</template>

<script>
export default {
  name: 'ComprehensiveResultsCard',
  components: {},
  filters: {
    displayText (item) {
      return item || '--'
    }
  },
  mixins: {},
  props: {
    level: {
      required: true
    },
    isLoad: {
      type: Boolean,
      required: true
    }
  },
  data: function () {
    return {}
  },
  computed: {},
  watch: {},
  created () {},
  methods: {}
}
</script>

<style lang="scss" scoped>
  .bg-lightgreen {
    background-color: #28a74520;
  }
</style>
